import React, { useState, useEffect } from "react";
import "./style.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import {
  formDataGenerator,
  getRouting,
  getYoutubePosterImage,
} from "../../../../../utils/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";
import { knowledgeMDsubscribeEmail } from "../actions";
import { mdVideosList, mdArticleList, mdInterviewArticleList } from "../actions";
import { Helmet } from "react-helmet";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import InfiniteScroll from 'react-infinite-scroll-component';

const NewMDCeoDesk = (props) => {
  const {
    knowledgeMDsubscribeEmail,
    subscriptionData,
    mdVideosList,
    mdArticleList,
    mdInterviewArticleList,
    mdVideosLists,
    MdArticleLists,
    mdInterviewArticleLists,
    location: { pathname },
  } = props;

  const getCurrent = (nc) => {
    switch (nc) {
      case "videos":
        return 0;
      case "articles":
        return 1;
      case "interviews":
        return 2;
      default:
        return 0;
    }
  };

  const current = pathname.split("/")[3];
  const [metaData, setMetaData] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [limit, setLimit] = useState(6);
  const [offset, setOffset] = useState(0);
  const [selectedTab, setSelectedTab] = useState(getCurrent(current));
  const [loading, setLoading] = useState(false);
  const [successMassage, setSuccessMassage] = useState(0);
  const [subscribeType, setSubscribeType] = useState("");
  // const [knowledgeStackType, setKnowledgeStackType] = useState(current);
  const [flag , setFlag] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
  }, []);

  // useEffect(() => {
  //   if (current) {
  //     setKnowledgeStackType(current);
  //   }
  // }, [current]);

  // useEffect(() => {
  //   if (knowledgeStackType === "videos") {
  //     setSelectedTab(0);
  //   }
  //   if (knowledgeStackType === "articles") {
  //     setSelectedTab(1);
  //   }
  //   if (knowledgeStackType === "interviews") {
  //     setSelectedTab(2);
  //   }
  // }, [knowledgeStackType]);

  const fetchMoreVideos = () => {
    if (loading) return; // Prevent multiple API calls
  
    setLoading(true); // Start loading
  
    const newOffset = offset + limit;
    let params = {
      search: "",
      limit: limit,
      offset: newOffset,
      tags: "",
    };
    if(selectedTab == 0){
      mdVideosList(formDataGenerator(params), "videos", true).then(() => {setOffset(newOffset);}).finally(() => {
        setLoading(false);
      });
    }
    if(selectedTab == 1){
      mdArticleList(formDataGenerator(params), "mdArticles", true).then(() => {setOffset(newOffset);}).finally(() => {
        setLoading(false);
      });
    }
    if(selectedTab == 2){
      mdInterviewArticleList(formDataGenerator(params), "mdInterviews", true).then(() => {setOffset(newOffset);}).finally(() => {
        setLoading(false);
      });
    }
  };

  const handleTabChange = async (e, value) => {
      setFlag(true);
      // setKnowledgeStackType(value);
      setSelectedTab(value);
      setOffset(0);
      setMetaData();
      setSubscribeType();
      setSuccessMassage(0);
  };
  
  useEffect(() => { 
    let params = {
      search: "",
      limit: limit,
      offset: 0,
      tags: "",
    };
    if(selectedTab == 0){
      !(mdVideosLists && mdVideosLists.latestVideos && flag == false) && mdVideosList(formDataGenerator(params), "videos", false);
    }
    if(selectedTab == 1){
      !(MdArticleLists && MdArticleLists.latestPosts && flag == false) && mdArticleList(formDataGenerator(params), "mdArticles", false);
    }
    if(selectedTab == 2){
      !(mdInterviewArticleLists && mdInterviewArticleLists.latestPosts && flag == false) && mdInterviewArticleList(formDataGenerator(params), "mdInterviews", false);
    }
  }, [selectedTab]);

  useEffect(()=>{
    if(flag == true){
      setFlag(false);
    }
  },[flag]);

  useEffect(() => {
    if (mdVideosLists ) {
      setTotalRecords(mdVideosLists.count ? mdVideosLists.count : 0);
      setMetaData(mdVideosLists && mdVideosLists.meta);
      setSubscribeType("MDspeaks Video")
    }
    if (MdArticleLists ) {
      setTotalRecords(MdArticleLists.count ? MdArticleLists.count : 0);
      setMetaData(MdArticleLists && MdArticleLists.meta);
      setSubscribeType("MDspeaks Articles")
    }
    if (mdInterviewArticleLists) {
      setTotalRecords(mdInterviewArticleLists.count ? mdInterviewArticleLists.count : 0);
      setMetaData(mdInterviewArticleLists && mdInterviewArticleLists.meta);
      setSubscribeType("Media Interview")
    }
  }, [mdVideosLists, MdArticleLists, mdInterviewArticleLists]);

  let thresholdValue =
  typeof window !== "undefined" && window.innerWidth > 1170
      ? "0.4"
      : typeof window !== "undefined" && window.innerWidth > 320 && window.innerWidth < 767
      ? "0.2"
      : "0.35";

  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Email is not correct').required('Please enter your address details'), 
  });

  const formik = useFormik({
    initialValues: {
        email: '',
    },
    validationSchema,
    // validateOnChange: false,
    // validateOnBlur: false,
    onSubmit: (data) => {
      let payload = {
        email: data.email,
        type: subscribeType && subscribeType,
        article: ""
      } 
      knowledgeMDsubscribeEmail(formDataGenerator(payload));
    },
  }); 
  
  useEffect(() => {
      if(subscriptionData && subscriptionData.message)
      {
        setSuccessMassage(1);
        formik.resetForm()
        setTimeout(() => {
            setSuccessMassage(0);
        }, 30000);
      }
  },[subscriptionData]) 

  return (
    <>
      <div className="wrapper">
        {metaData && metaData !== null && (
          <Helmet>
            <title>{metaData.title ? metaData.title : ""}</title>
            <meta
              name="description"
              content={metaData.description ? metaData.description : ""}
            />
            <meta
              name="keywords"
              content={metaData.keywords ? metaData.keywords : ""}
            />
            <meta
              property="og:title"
              content={metaData.og_title ? metaData.og_title : ""}
            />
            <meta
              property="og:description"
              content={metaData.og_description ? metaData.og_description : ""}
            />
            <meta
              property="og:image"
              content={metaData.og_image ? metaData.og_image : ""}
            />
            <meta
              property="og:url"
              content={metaData.og_url ? metaData.og_url : ""}
            />
          </Helmet>
        )}

        <section className="aboutHead">
          <div className="container">
            <div className="d-flex dropdowncls">
              <div className="dropdown me-auto">
                <div>
                  <h1>
                    <span>Message from </span>MD & CEO's Desk
                  </h1>
                </div>
              </div>
              <nav
                aria-label="breadcrumb"
                className="align-self-center breadCrumbCust d-md-inlin"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={getRouting(`/`)}>Home</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={getRouting(`/knowledge-stack`)}>
                      Knowledge Stack
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item active breadcolor"
                    aria-current="page"
                  >
                    Message from MD & CEO's Desk
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </section>
        <section>
          <div className="container">
            <div className="mdbannerdiv">
              <div className="row">
                <div className="col-md-8 my-md-auto mainbanner">
                  <div className="mdheading">
                    <p className="mdtitle">Insights and Thoughts from</p>
                    <h2 className="mdname">Navneet Munot</h2>
                    <p className="position">Managing Director and Chief Executive Officer</p>
                    <p className="vissionMission ">
                    “Our  mission is to be the wealth creator for every Indian and <br/>
                    Our vision is to be the most respected asset manager in the world”
                    </p>
                  </div>
                </div>
                <div className="col-md-4 mdimgdiv">
                  <div className="d-flex justify-content-center text-center">
                    <img src="/images/New/KnowledgeStack/mdBannerImg.webp" alt="MD Banner"/>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <Tabs className="customTab" selectedIndex={selectedTab} >
                <TabList className="myClass slickOptions">
                  <Link
                    to={getRouting("/knowledge-stack/md-ceo-desk/videos", "Videos")}
                  >
                    <Tab
                      onClick={async (e) => {
                        // setBradeCrump("IAP Downloads");
                        await handleTabChange(e, 0);
                      }}
                      tabFor="0"
                      value={0}
                    >
                      <div>
                        <p>Videos</p>
                      </div>
                    </Tab>
                  </Link>
                  <Link
                    to={getRouting("/knowledge-stack/md-ceo-desk/articles", "Articles")}
                  >
                    <Tab
                      onClick={async (e) => {
                        // setBradeCrump("IAP Downloads");
                        await handleTabChange(e, 1);
                      }}
                      tabFor="1"
                      value={1}
                    >
                      <div>
                        <p>Articles</p>
                      </div>
                    </Tab>
                  </Link>
                  <Link
                    to={getRouting("/knowledge-stack/md-ceo-desk/interviews", "Interviews")}
                  >
                    <Tab
                      onClick={async (e) => {
                        // setBradeCrump("IAP Downloads");
                        await handleTabChange(e, 2);
                      }}
                      tabFor="2"
                      value={2}
                    >
                      <div>
                        <p>Interviews</p>
                      </div>
                    </Tab>
                  </Link>
                </TabList>
                <TabPanel>
                  <div className="product-list">
                    <InfiniteScroll
                      style={{ overflow: "none" }}
                      next={fetchMoreVideos}
                      scrollThreshold={thresholdValue}
                      hasMore={offset + limit < totalRecords  && !loading}
                      loader={loading ? <div className="d-flex justify-content-center"><div className="loadergif" /></div> : null}
                      // endMessage={!loading ? <div className="text-center nodata">No More Videos</div> : null} 
                      dataLength={mdVideosLists?.latestVideos?.length}
                    >
                      <div className="row my-4"> 
                        {mdVideosLists &&
                          mdVideosLists.latestVideos &&
                          mdVideosLists.latestVideos.length > 0 && (
                            mdVideosLists.latestVideos.map((data, index) => {
                              const compareVideo = data && data.image_url;
                              const posterImage = getYoutubePosterImage(data && data.youtubeId);
                              return !compareVideo ? (
                                <div className="col-md-4 mb-3" key={index}>
                                  <a href={`/knowledge-stack/md-ceo-desk/videos/${data && data.suggestedUrl}`}>
                                    <div className="card">
                                      {posterImage ? (
                                        <img src={posterImage} alt="card image" className="card-img-top w-100" />
                                      ) : (
                                        <img src="/images/New/learnNew/articlesimg.svg" alt="card image" className="card-img-top w-100" />
                                      )}
                                      <div className="card-body px-0">
                                        <p className="card-title">{data && data.title}</p>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              ) : (
                                <div key={index}>
                                  <div className="middle-banner">
                                    <div className="shadows">
                                      <div className="redtag">Latest</div>
                                    </div>
                                    <div className="middle-img">
                                      <img src={data && data.image_url && data.image_url.url} alt={data && data.image_url && data.image_url.alt} />                            
                                      <div className="details">
                                        <h3>{data && data.title}</h3>
                                        {data && data.body ? (
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: data.body,
                                            }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                        )}
                      </div>
                    </InfiniteScroll>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="product-list">
                    <InfiniteScroll
                      style={{ overflow: "none" }}
                      next={fetchMoreVideos}
                      scrollThreshold={thresholdValue}
                      hasMore={offset + limit < totalRecords  && !loading}
                      loader={loading ? <div className="d-flex justify-content-center"><div className="loadergif" /></div> : null}
                      // endMessage={!loading ? <div className="text-center nodata">No More Articles</div> : null} 
                      dataLength={MdArticleLists?.latestPosts?.length}
                    >
                      <div className="row my-4">
                        {MdArticleLists &&
                        MdArticleLists.latestPosts &&
                        MdArticleLists.latestPosts.length > 0 &&
                        (MdArticleLists.latestPosts.map((data, index) => (
                          <div className="col-md-4 mb-3" key={index}>
                            <a href={`/knowledge-stack/md-ceo-desk/articles/${data && data.suggestedUrl}`}>
                              <div className="card">
                                <img src={data && data.thumbnail_image && data.thumbnail_image.url ? data.thumbnail_image.url : '/images/New/learnNew/articlesimg.svg'} 
                                  alt={data && data.thumbnail_image && data.thumbnail_image.alt ? data.thumbnail_image.alt : ''} className="card-img-top w-100" />
                                <div className="card-body px-0">
                                  <h2 className="card-title">{data && data.title ? data.title : ''}</h2>
                                  <div className="datetime">
                                    <p>{data && data.publishedDate ? data.publishedDate : ''}</p>
                                    <p>{data && data.time ? data.time : ''}</p>
                                  </div>
                                  <p className="card-text">{data && data.description ? data.description : ''}</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          )))
                        }
                      </div>
                    </InfiniteScroll>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="product-list">
                    <InfiniteScroll
                      style={{ overflow: "none" }}
                      next={fetchMoreVideos}
                      scrollThreshold={thresholdValue}
                      hasMore={offset + limit < totalRecords  && !loading}
                      loader={loading ? <div className="d-flex justify-content-center"><div className="loadergif" /></div> : null}
                      // endMessage={!loading ? <div className="text-center nodata">No More Interviews</div> : null} 
                      dataLength={mdInterviewArticleLists?.latestPosts?.length}
                    >
                      <div className="row my-4">
                        {mdInterviewArticleLists &&
                        mdInterviewArticleLists.latestPosts &&
                        mdInterviewArticleLists.latestPosts.length > 0 &&
                        (mdInterviewArticleLists.latestPosts.map((data, index) => (
                          <div className="col-md-4 mb-3" key={index}>
                            <a href={data && data.linkUrl} target="_blank">
                              <div className="card">
                                <img src={data && data.thumbnail_image && data.thumbnail_image.url ? data.thumbnail_image.url : '/images/New/learnNew/articlesimg.svg'}
                                alt={data && data.thumbnail_image && data.thumbnail_image.alt ? data.thumbnail_image.alt : ''} className="card-img-top w-100" />
                                <div className="card-body px-0">
                                  <h5 className="card-title">{data && data.title ? data.title : ''}</h5>
                                  {/* <p className="card-title">{data && data.description ? data.description : ''}</p> */}
                                </div>
                              </div>
                            </a>
                          </div>
                          )))
                        }
                      </div>
                    </InfiniteScroll>
                  </div>
                </TabPanel>
              </Tabs>
              <div>
                {successMassage === 0 ?
                  <form onSubmit={formik.handleSubmit}>
                    <div className='bg-warning mt-5 mb-5'>
                      <div className='row px-3 py-5'>
                        <div className='col-md-9 mx-auto'>
                        {/* <h3 class="text-center mb-3">Did you find this interesting</h3> */}
                        <p className='text-center mb-3'>Subscribe to our exclusive newsletter to get our latest updates</p>
                        </div>
                        <div className="col-md-9 mx-auto">
                          <div>
                            <div className='row'>
                              <div className="col-md-8 mb-3">
                                <input type="text" placeholder="Email Address" name='email' onChange={formik.handleChange} value={formik.values.email} className={ 'invalid form-control' + (formik.errors.email && formik.touched.email ? ' is-invalid' : '')} autoComplete='off' aria-autocomplete="none" />
                                {/* <Form.Control type="text" placeholder="Enter Addess" name='email' onChange={formik.handleChange} value={formik.values.email} className={ 'invalid' + (formik.errors.email && formik.touched.email ? ' is-invalid' : '')}  /> */}
                                <div className="invalid-feedback">
                                  {formik.errors.email && formik.touched.email ? formik.errors.email : null}
                                </div>
                              </div>
                              <div className="col-md-4 mb-3">
                                <button className='w-100 btn btn-primary' type="submit">Subscribe</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form> : 
                  <div className='bg-warning mt-5 mb-5'>
                    <div className='row px-3 py-5 thanks'>
                      <div className="col-md-6 mx-auto">
                        <div>
                        <h3 className='text-center mb-3'>Did you find this interesting</h3>
                          <p className='text-center mb-3'>Subscribe to get latest updates</p>
                          <button className='w-100 btn btn-light' type="button">Thanks For Signing Up</button>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div >
          </div>
        </section >
      </div >
    </>
  );
};

const mapStateToProps = (state) => ({
  subscriptionData: state.KnowledgeStack.subscribeEmailResponse,
  mdVideosLists: state.KnowledgeStack.mdVideosData,
  MdArticleLists: state.KnowledgeStack.mdArticleData,
  mdInterviewArticleLists: state.KnowledgeStack.mdInterviewArticleData,
});

const mapDispatchToProps = (dispatch) => ({
  knowledgeMDsubscribeEmail: bindActionCreators(knowledgeMDsubscribeEmail, dispatch),
  mdVideosList: bindActionCreators(mdVideosList, dispatch),
  mdArticleList: bindActionCreators(mdArticleList, dispatch),
  mdInterviewArticleList: bindActionCreators(mdInterviewArticleList, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewMDCeoDesk);